"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.hasConsent = exports.CUSTOM_CONSENT_FIELD_ID = exports.CUSTOM_CONSENT_FLAG = exports.EventStatuses = exports.EventTypes = exports.SocialLinkNames = exports.getVisibilityRuleStates = exports.splitSweepstakesDisclaimer = exports.SweepstakesDisclaimerTokens = exports.UserEventStates = void 0;
__exportStar(require("./lightshow"), exports);
var UserEventStates;
(function (UserEventStates) {
    UserEventStates[UserEventStates["draft"] = 0] = "draft";
    UserEventStates[UserEventStates["submitted"] = 1] = "submitted";
    UserEventStates[UserEventStates["registered"] = 2] = "registered";
})(UserEventStates || (exports.UserEventStates = UserEventStates = {}));
/**
 * Placeholder tokens supported by {@link Register.sweepstakesDisclaimer}.
 *
 * `{rules}` marks where the Official Rules link goes; `{cta}` is replaced with
 * the registration button's label.
 */
exports.SweepstakesDisclaimerTokens = {
    rules: "{rules}",
    cta: "{cta}",
};
/**
 * Splits a custom sweepstakes disclaimer into the text segments surrounding the
 * `{rules}` token, resolving `{cta}` on the way through. Consumers render the
 * Official Rules link *between* the returned segments, so the link stays a real
 * element rather than markup an author could break or omit.
 *
 * Always returns at least two segments: when `{rules}` is missing the link is
 * appended to the end instead of being dropped, since the rules link has to
 * remain reachable on every sweepstakes form (ENG-2132).
 */
const splitSweepstakesDisclaimer = (disclaimer, ctaLabel = "") => {
    const resolved = disclaimer
        .split(exports.SweepstakesDisclaimerTokens.cta)
        .join(ctaLabel);
    const segments = resolved.split(exports.SweepstakesDisclaimerTokens.rules);
    return segments.length > 1 ? segments : [...segments, ""];
};
exports.splitSweepstakesDisclaimer = splitSweepstakesDisclaimer;
const getVisibilityRuleStates = (rules) => {
    if (Array.isArray(rules.states)) {
        return rules.states;
    }
    return [];
};
exports.getVisibilityRuleStates = getVisibilityRuleStates;
exports.SocialLinkNames = [
    "facebook",
    "instagram",
    "tiktok",
    "spotify",
    "youtube",
    "twitter",
    "shazam",
];
var EventTypes;
(function (EventTypes) {
    EventTypes[EventTypes["Swiper"] = 0] = "Swiper";
    EventTypes[EventTypes["Round"] = 1] = "Round";
    EventTypes[EventTypes["Cards"] = 2] = "Cards";
    EventTypes[EventTypes["Boxy"] = 3] = "Boxy";
    EventTypes[EventTypes["Grunge"] = 4] = "Grunge";
})(EventTypes || (exports.EventTypes = EventTypes = {}));
exports.EventStatuses = [
    "published",
    "unpublished",
    "deleted",
    "demo",
    "draft",
];
/**
 * The flag stored on the user doc for the custom consent response
 */
exports.CUSTOM_CONSENT_FLAG = "custom-consent";
/**
 * The field ID to use for the custom consent field in the event config
 */
exports.CUSTOM_CONSENT_FIELD_ID = "consent";
/**
 * Returns true if the user/entry has consented to the event's opt-in for email
 * communications.
 */
const hasConsent = (user, eventConfig) => {
    var _a, _b, _c;
    const consent = "values" in user
        ? user.values[exports.CUSTOM_CONSENT_FLAG]
        : user[exports.CUSTOM_CONSENT_FLAG];
    const terms = "values" in user ? user.values.terms : user.terms;
    // if the event has a custom "consent" field, we should prioritize using that value
    // for email consent instead of the "terms" agreement
    const customConsent = ((_b = (_a = eventConfig === null || eventConfig === void 0 ? void 0 : eventConfig.register) === null || _a === void 0 ? void 0 : _a.customFields) === null || _b === void 0 ? void 0 : _b.some((x) => x.id === exports.CUSTOM_CONSENT_FIELD_ID))
        ? consent
        : undefined;
    return (_c = customConsent !== null && customConsent !== void 0 ? customConsent : terms) !== null && _c !== void 0 ? _c : false;
};
exports.hasConsent = hasConsent;
//# sourceMappingURL=event.js.map